import React, { useState } from 'react';
import ListItem from './components/ListItem';

import styles from './style.module.scss';

const FAQData = [
  {
    question: 'What is HeeBenor Diamond Mosaic?',
    answer:
      'Diamond mosaic from HeeBenor is the novelty of the year!\r\n\r\nThis is a unique mosaic that allows you to assemble your own photo, no more blueprint bouquets, and a long wait for a set to order, our generator allows you to choose which picture to post, it can be you, your cat or even a neighbor from the 3rd floor , no restrictions, only the flight of your imagination!\r\n\r\nYou can assemble both a horizontal and vertical picture, and thanks to the universal A3 and A4 formats, any photo will fit!\r\n\r\nDiamond mosaic HeeBenor on magnetic bases is a set of three square magnetic bases and crystals, from which you can collect all 3 color schemes: ORIGINAL, VINTAGE and POP-ART. Finished paintings will be an excellent decoration for a metal surface!',
  },
  {
    question: 'Which photo to choose for your painting?',
    answer:
      'You can use any image from cameras, from social networks. networks, from phones, or photographs on paper that you can scan and download. The best option for the main photo would be a portrait image of one or more people with well-visible facial features. The fewer small details present in the main photo, the better the result will be. The instruction generator will offer several options for assembling the mosaic. You just have to choose the option you like best.',
  },
  {
    question: 'How can I get mosaic assembly instructions after purchase?',
    answer:
      'Each set has an instruction in which you will find a unique code consisting of 9 characters. Then everything is simple: on our website you enter this code, the system independently generates several layout options for you, you choose the prettiest one, enter your e-mail and receive detailed instructions to the specified address.',
  },
  {
    question:
      'Will it be possible to peel off the crystal if I glued it incorrectly?',
    answer:
      'Certainly! Each set has a stylus with which the mosaic is laid out, and with its help, you can easily remove or move an incorrectly glued crystal.',
  },
  {
    question: 'How long does it take to assemble a mosaic from HeeBenor?',
    answer:
      'It all depends on build speed. On average, an A4 kit takes about 18-20 hours to assemble, an A3 kit takes 40 hours to assemble, and one magnetic base can be assembled in about 10 hours.',
  },
  {
    question:
      'The number of rhinestones is for painting only? Or do you still have rhinestones in reserve in case of any circumstances?',
    answer:
      'We always put 40% more crystals than what is actually required for the assembly.',
  },
  {
    question: "If I don't like the assembled picture?",
    answer:
      'In order to avoid this, before buying and assembling, you can see how the picture will look like in a diamond layout using the free instruction generator on our website.',
  },
  {
    question: 'Will the photo I uploaded appear on the Internet?',
    answer:
      'After generating the instruction, all source materials are deleted.',
  },
  {
    question: 'Will a small child be able to assemble a picture?',
    answer:
      'This picture is designed for adults and children from 8 years. Be sure to perform this work by children only under the supervision of adults, as the kit contains many small parts.',
  },
  {
    question: 'I did not receive an email with assembly instructions.',
    answer:
      'Please check your SPAM folder and make sure your email is correct. And also you can start building by downloading the pdf file from our generator. If there is no instruction, write to us at service@diypaintings.com and we will definitely help!',
  },
  {
    question: 'Can you send me the finished painting?',
    answer:
      'We believe that the essence of the product is in the process of assembling a personalized image, we do not release finished paintings.',
  },
  {
    question: 'What is a diamond photo mosaic made of?',
    answer:
      'All crystals are made of high quality acrylic. We have all certificates of conformity.',
  },
  {
    question: 'Is the diamond painting laid out completely or are there gaps?',
    answer: 'Our mosaic is laid out with rhinestones completely.',
  },
  {
    question: 'Can I frame the assembled mosaic?',
    answer:
      'Yes, you can insert HeeBenor A4 sets on a cardboard backing into a frame, both horizontally and vertically.',
  },
  {
    question: 'What shape are the crystals in your kits?',
    answer: 'Our mosaic is laid out with square rhinestones.',
  },
  {
    question: 'It is included in the kit?',
    answer:
      'The A4 set includes: MDF base on a stretcher, 16,000 crystals (ORIGINAL) and 22,000 (VINTAGE, POP-ART), stylus, rhinestone tray, detailed instructions with a unique code, wax plate and bags for storing crystals.\r\n\r\nThe A3 set includes: Base on MDF stretcher, 32000 crystals (ORIGINAL) and 44000 (VINTAGE, POP-ART), 2 styluses, 2 trays for rhinestones, detailed instructions with a unique code, 2 wax plates and bags for storing crystals.\r\n\r\nThe set of A4 format on a cardboard substrate includes: Base, 16000 crystals (ORIGINAL) and 22000 (VINTAGE, POP-ART), stylus, rhinestone tray, detailed instructions with a unique code, wax plate and bags for storing crystals.\r\n\r\nThe magnetic base kit includes: 3 magnetic bases, 3 styluses, 3 wax plates, 7 rhinestone trays, instructions with assembly code and 22800 rhinestones (19 bags).',
  },
  {
    question: 'What is the size of the rhinestone?',
    answer:
      'For sets on a cardboard substrate, there are rhinestones with a diameter of 2.3 mm. For sets on a rigid stretcher and on magnetic bases, 2.5 mm crystals, mosaics are made in high quality, so that the picture has the best detail.',
  },
  {
    question: 'What if my question is not listed in the FAQ?',
    answer:
      "If you couldn't find the answer to your question, write to us at service@diypaintings.com",
  },
  {
    question: 'How to become your representative?',
    answer:
      'You can find out more information about cooperation by writing to us at service@diypaintings.com',
  },
];
const FAQ = () => {
  const [expandItem, setExpandItem] = useState<number | null>(null);

  return (
    <div className={styles.wrapper}>
      <div className={styles.faqPage}>
        <h1>FAQ</h1>
        <ul className={styles.faqList}>
          {FAQData?.length > 0 &&
            FAQData.map((item: any, key) => (
              <ListItem
                id={key}
                question={item.question}
                answer={item.answer}
                isExpand={expandItem === key}
                setExpandItem={setExpandItem}
                key={key}
              />
            ))}
        </ul>
      </div>
    </div>
  );
};

export default FAQ;
